import React from 'react';
import { PiArrowsClockwise } from 'react-icons/pi';
import { iconsPath } from '../../../utils/imagePath';

const PreviewControls = ({
  isOpen,
  onToggle,
  previewAutoRotateCamera,
  setPreviewAutoRotateCamera,
  previewCameraId,
  setPreviewCameraId,
  previewSceneCameras = [],
}) => {
  const isAutoRotateDisabled = Boolean(previewCameraId);

  return (
    <div className="fixed top-3 right-3 z-[100000] select-none font-inter">
      <div className="w-[240px] rounded-[12px] border border-[#2c2f35] bg-[#131418] overflow-hidden">
        <button
          type="button"
          className="w-full flex items-center justify-between gap-3 px-3 py-2.5 text-white hover:bg-[#1d1e21] transition-colors duration-150"
          onClick={onToggle}
        >
          <span className="text-[12px] font-light tracking-wide">
            Preview Controls
          </span>
          <img
            src={iconsPath?.vectorImage}
            alt=""
            className={`h-2.5 w-2.5 opacity-70 transition-transform duration-300 ${
              isOpen ? 'rotate-180' : 'rotate-0'
            }`}
          />
        </button>

        {isOpen && (
          <div className="border-t border-[#2c2f35] px-3 py-3 flex flex-col gap-3">
            <div className="flex items-center justify-between gap-3 rounded-[5px] bg-[#1d1e21] px-3 py-2.5">
              <div className="flex items-center gap-2 min-w-0">
                <PiArrowsClockwise
                  size={14}
                  className={`shrink-0 ${
                    isAutoRotateDisabled ? 'text-[#6b6b6b]' : 'text-[#a6a6a6]'
                  }`}
                />
                <div className="min-w-0">
                  <p
                    className={`text-[11px] text-white leading-tight ${
                      isAutoRotateDisabled ? 'opacity-50' : ''
                    }`}
                  >
                    Auto Rotate Camera
                  </p>
                  {isAutoRotateDisabled && (
                    <p className="text-[9px] text-[#8A8888] mt-0.5 leading-tight">
                      Disabled while a scene camera is active
                    </p>
                  )}
                </div>
              </div>
              <button
                type="button"
                role="switch"
                aria-checked={previewAutoRotateCamera}
                aria-label="Toggle auto rotate camera"
                disabled={isAutoRotateDisabled}
                onClick={() =>
                  setPreviewAutoRotateCamera(!previewAutoRotateCamera)
                }
                className={`relative h-5 w-9 shrink-0 rounded-full border transition-all duration-200 ${
                  previewAutoRotateCamera
                    ? 'bg-[#a6a6a6] border-[#c8c8c8]'
                    : 'bg-[#444447] border-[#545454]'
                } ${
                  isAutoRotateDisabled
                    ? 'opacity-40 cursor-not-allowed'
                    : 'cursor-pointer'
                }`}
              >
                <span
                  className={`absolute top-0.5 left-0.5 h-3.5 w-3.5 rounded-full shadow-sm transition-all duration-200 ${
                    previewAutoRotateCamera
                      ? 'translate-x-[18px] bg-white'
                      : 'translate-x-0 bg-[#8A8888]'
                  }`}
                />
              </button>
            </div>

            <div>
              <div className="flex items-center justify-between mb-2">
                <span className="text-[10px] uppercase tracking-wide text-[#a6a6a6]">
                  Cameras
                </span>
                <span className="text-[9px] text-[#6b6b6b]">
                  {previewSceneCameras.length + 1} total
                </span>
              </div>

              <div className="flex flex-col gap-1 max-h-[200px] overflow-y-auto pr-0.5">
                <button
                  type="button"
                  className={`w-full text-left px-3 py-2 rounded-[5px] text-[11px] transition-colors duration-150 ${
                    !previewCameraId
                      ? 'bg-[#2D2E32] text-white border border-[#565759]'
                      : 'text-[#d0d0d0] hover:bg-[#1d1e21] border border-transparent'
                  }`}
                  onClick={() => setPreviewCameraId(null)}
                >
                  Default View
                </button>

                {previewSceneCameras.length === 0 ? (
                  <div className="px-3 py-2 text-[10px] text-[#8A8888] rounded-[5px] bg-[#1d1e21]">
                    No camera assets in scene
                  </div>
                ) : (
                  previewSceneCameras.map((cam) => {
                    const isActive = previewCameraId === cam.id;
                    const typeLabel = cam.typeLabel || 'Perspective';
                    const typeShort =
                      typeLabel === 'Orthographic' ? 'Ortho' : 'Persp';
                    return (
                      <button
                        key={cam.id}
                        type="button"
                        title={`${cam.label} (${typeLabel})`}
                        className={`w-full text-left px-3 py-2 rounded-[5px] text-[11px] truncate transition-colors duration-150 ${
                          isActive
                            ? 'bg-[#2D2E32] text-white border border-[#565759]'
                            : 'text-[#d0d0d0] hover:bg-[#1d1e21] border border-transparent'
                        }`}
                        onClick={() => setPreviewCameraId(cam.id)}
                      >
                        {cam.label}
                        <span className="ml-1 text-[#8A8888] text-[10px]">
                          {typeShort}
                        </span>
                      </button>
                    );
                  })
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PreviewControls;
